import React from "react";
import {ItemHeader} from "./ItemHeader.jsx";
import {ItemContent} from "./ItemContent.jsx";

export default function SideSelectionItem({iconName, header, content}) {
    return (
        <div className={"side-section-details"}>
            <div className={"side-section-details-item"}>
                <ItemHeader iconName={iconName} headline={header} />
                <ItemContent text={content} />
            </div>
        </div>
    );
}